import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { generatePath, useNavigate } from 'react-router-dom'
import ROUTES from '../assets/routes'
import { selectDefaultLayoutId } from '../selectors/user'
import { selectIsMobile } from '../selectors/device'
import { Platform } from '../proto/generated/user-preference'

const HomePage: React.FC = () => {
    const navigate = useNavigate()
    const isMobile = useSelector(selectIsMobile)
    const defaultLayoutId = useSelector(selectDefaultLayoutId(isMobile ? Platform.MOBILE : Platform.DESKTOP))

    useEffect(() => {
        if (defaultLayoutId) {
            navigate(generatePath(ROUTES.chart, {layoutId: defaultLayoutId}), {replace: true})
        }
    }, [defaultLayoutId])


    return null
}

export default HomePage